import { InjectionToken } from '@angular/core';
import { ColumnSetting, CtColumn, NameIdModel } from '@ct/model';

export const PROJECT_PREFIX = new InjectionToken<string>('Project prefix');
export const VESSEL_TYPES = new InjectionToken<Map<string, NameIdModel>>('Vessel types');
export const NAVIGATION = new InjectionToken<string>('Navigation setup');
export const COLUMNS = new InjectionToken<CtColumn[]>('Columns');
export const COLUMN_SETTINGS = new InjectionToken<ColumnSetting[]>('Column settings');
